import { render } from "./CommonUser.vue?vue&type=template&id=fb0b01e4"
import script from "./CommonUser.vue?vue&type=script&lang=js"
export * from "./CommonUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__